import { QueryParam } from "../enums";

export interface RedirectType {
    Error: {
        Code: string;
        Message: string;
        RedirectUrl: string;
        Data: string;
    };
}

export async function establishRedirect(response: Response): Promise<string> {
    const redirectJson = await response.json() as RedirectType;
    if (redirectJson.Error.Code !== "Redirect") {
        throw new Error("Unexpected code from redirect status code: " + redirectJson.Error.Code);
    }
    const establishSessionResponse = await fetch(redirectJson.Error.RedirectUrl + "/api/auth/session/establishSession", {
        method: "POST",
        body: redirectJson.Error.Data,
        mode: "cors",
        credentials: "include"
    });
    if (!establishSessionResponse.ok) {
        throw new Error("Session redirection failed.");
    }
    return redirectJson.Error.RedirectUrl;
}

export async function handleRedirectResponse(response: Response, inNewTab?: boolean, companyId?: number): Promise<void> {
    let redirectUrl = await establishRedirect(response);
    if (companyId) {
        redirectUrl = `${redirectUrl}?${QueryParam.CompanyId}=${companyId}`;
    }
    if (inNewTab) {
        window.open(redirectUrl, "_blank");
    } else {
        window.location.assign(redirectUrl);
    }
}